import { render, staticRenderFns } from "./CreateFieldDialog.vue?vue&type=template&id=8b9dd1f4&scoped=true&"
import script from "./CreateFieldDialog.vue?vue&type=script&lang=js&"
export * from "./CreateFieldDialog.vue?vue&type=script&lang=js&"
import style0 from "./CreateFieldDialog.vue?vue&type=style&index=0&id=8b9dd1f4&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b9dd1f4",
  null
  
)

export default component.exports